import { AuthenticatedHttp } from '@/http/axios';

export const fetchBannerService = async (from) => {
  const params = from;

  return AuthenticatedHttp.get(`/banners/`, { params }).then(({ data, erro }) => {
    if (erro) {
      throw new Error('Banner não encontrado');
    }

    return data;
  });
};
